const translations: Record<string, string> = {
  "ak_dsp2_actual_pv_bess_discharge_saved_h_for": "Actual (PV + BESS discharge) saved ({{n}} h) for {{d}}.",
  "ak_dsp2_actual_generation_saved_h_for": "Actual generation saved ({{n}} h) for {{d}}.",
  "ak_dsp2_mms_schedule_saved_version_entry_added": "MMS schedule saved (version {{rev}}) - entry added to \"Saved schedules\". Your solar plant: {{own}} kWh, group: {{grp}} kWh",
  "ak_dsp2_error": "error",
  "ak_dsp2_mms_schedule_ver": "MMS schedule: ver. {{r}}",
  "ak_dsp2_editing_actuals_pv_generation_bess_dis": "Editing actuals: PV generation + BESS discharge",
  "ak_dsp2_editing_the_actual_row": "Editing the \"Actual\" row",
  "ak_dsp2_editing_the_uploaded_to_mms_row_versio": "Editing the \"Uploaded to MMS\" row (version {{rev}})",
  "ak_dsp2_hours_changed": "hours changed: {{n}}",
  "ak_dsp2_manually_adjusted_model_kwh": "Manually adjusted{{by}}. Model: {{m}} kWh",
  "ak_dsp2_the_schedule_for_this_day_can_no_longe": "The schedule for this day can no longer be edited: the deadline of version {{rev}} has passed. ",
  "ak_dsp2_a_schedule_can_only_be_submitted_for_a": "A schedule can only be submitted for a day whose deadline has not yet passed - choose",
  "ak_dsp2_or_a_later_date": " or a later date.",
  "ak_dsp2_forecast_values_are_pre_filled_edit_on": "Forecast values are pre-filled - edit only the hours that differ. Only this solar plant's contribution is saved; the group total for the X-code is recalculated automatically, and for group members not yet edited their forecast is used. A previously generated XML will be invalidated - regenerate it after editing.",
  "ak_dsp2_no_changes_to_save": "No changes to save.",
  "ak_dsp2_failed_to_save": "Failed to save",
  "ak_dsp2_generation_forecast_kwh": "Generation forecast, kWh",
  "ak_dsp2_actual_generation_kwh": "Actual generation, kWh",
  "ak_dsp2_uploaded_to_mms_kwh": "Uploaded to MMS, kWh",
  "ak_dsp2_bess_charge_discharge_kwh": "BESS charge / discharge, kWh",
  "ak_dsp2_dam_price_uah_mwh": "DAM price, UAH/MWh",
  "ak_dsp2_actual_pv_generation_kwh": "Actual: PV generation, kWh",
  "ak_dsp2_actual_bess_discharge_kwh": "Actual: BESS discharge, kWh",
  "ak_dsp2_hourly_data": "Hourly data",
  "ak_dsp2_preparing": "Preparing…",
  "ak_dsp2_edit_actuals_enter_actual_generation_m": "Edit actuals - enter actual generation manually (Luchky solar plant, from 01.09.2026)",
  "ak_dsp2_edit_actuals_enter_manually_pv_generat": "Edit actuals - enter manually: PV generation + BESS discharge (Tabaky solar plant, past dates)",
  "ak_dsp2_no_active_schedule_version": "No active schedule version",
  "ak_dsp2_version_deadline_has_passed_the_schedu": "Version deadline has passed - the schedule cannot be edited",
  "ak_dsp2_edit_forecast_edit_the_uploaded_to_mms": "Edit forecast - edit the \"Uploaded to MMS\" row (forecast pre-filled)",
  "ak_dsp2_cancel": "Cancel",
  "ak_dsp2_saving": "Saving…",
  "ak_dsp2_save": "Save",
  "ak_dsp2_loading": "Loading…",
  "ak_dsp2_no_data_for_this_day": "No data for this day",
  "ak_dsp2_hour": "Hour",
  "ak_dsp2_value_taken_from_the_forecast_the_sche": "Value taken from the forecast - the schedule is not saved yet",
  "ak_dsp2_editing_is_available_to_the_operator_a": "Editing is available to the \"Operator\" and \"CTO\" roles.",
  "ak_dsp2_the_schedule_for_this_day_cannot_be_ed": "The schedule for this day cannot be edited: all versions are closed. ",
  "ak_dsp2_kwh": "kWh",
  "ak_dsp2_w_m": "W/m²",
  "ak_dsp2_forecast_adjusted_manually_model_gave": "forecast adjusted manually · model gave {{m}}",
  "ak_dsp2_generation_forecast": "Generation forecast",
  "ak_dsp2_actual_generation": "Actual generation",
  "ak_dsp2_to_grid": "  · to grid",
  "ak_dsp2_to_bess_charge": "  · to BESS charge",
  "ak_dsp2_auxiliary_use_imbalance": "  · auxiliary use / imbalance",
  "ak_dsp2_bess_discharge_to_grid": "BESS discharge to grid",
  "ak_dsp2_bess_soc_hourly_avg": "BESS SOC (hourly avg.)",
  "ak_dsp2_overperformance": "Overperformance",
  "ak_dsp2_shortfall": "Shortfall",
  "ak_dsp2_uploaded_to_mms": "Uploaded to MMS",
  "ak_dsp2_cloud_cover": "Cloud cover",
  "ak_dsp2_solar_radiation": "Solar radiation",
  "ak_dsp2_forecast_kwh": "Forecast, kWh",
  "ak_dsp2_actual_kwh": "Actual, kWh",
  "ak_dsp2_bess_charge": "BESS charge",
  "ak_dsp2_bess_discharge": "BESS discharge",
  "ak_dsp2_bess_soc": "BESS SOC, %",
  "ak_dsp2_bess_soc_2": "BESS SOC",
  "ak_dsp2_hourly_forecast_vs_actual_vs_mms": "Hourly forecast vs actual vs MMS",
  "ak_dsp2_generation_output_kwh": "Generation · output, kWh",
  "ak_dsp2_no_mms_schedule_was_saved_for_this_day": "no MMS schedule was saved for this day",
};

export default translations;
